import { Box } from '@mui/material';
import React, { ReactElement } from 'react';
import HeaderDivider from '../../common/header_divider.png';

interface ContentBodyProps {
  children: ReactElement;
}

const ContentBody = (props: ContentBodyProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        flexGrow: 1
      }}
    >
      <Box sx={{ width: '100%' }}>
        <img src={HeaderDivider} style={{ width: '100%', display: 'block', objectFit: 'cover' }} alt="header-divider" />
      </Box>
      {props.children}
    </Box>
  );
};

export default ContentBody;
